<template lang='html'>
  <div class='test-adult'>
    <div class='test_content_title2'>Step {{step + 1}} of {{stepsIdGroup.length}}</div>
    <step
      :questions='currentStepQuestion'
      :stepTitle='currentStepTitle'
      :stepDescription='currentStepDescription'
      :key='currentStep'
      v-if='stepsIdGroup.length'
      @onCompleteStep='handlerCompleteStep'>
    </step>
    <a class='test_button test_button_active' @click='nextStep' v-if='canNextStep'>NEXT</a>
    <a class='test_button test_button_active' @click='completeTest' v-if='showCompleteTest'>COMPLETE</a>
    <img class='test_bottom-img' src='/quiz/images/bottom-city.png'>
  </div>
</template>

<script>
import axios from 'axios';
import Step from './Step';

export default {
  name: 'test-adult',

  created (){
    window.addEventListener('beforeunload', this.beforePageDestroyed)
  },

  data() {
    return {
      step: 0,
      stepsIdGroup: [],
      stepsQuestionOfGroup: {},
      answersOfStep: [],
      canNextStep: false,
      showCompleteTest: false,
      getAnswers: () => {}
    };
  },

  computed: {
    currentStepQuestion() {
      return this.stepsQuestionOfGroup[this.currentStep] ? this.stepsQuestionOfGroup[this.currentStep] : null;
    },

    currentStepTitle() {
      return this.stepsQuestionOfGroup[this.currentStep][0].title ? this.stepsQuestionOfGroup[this.currentStep][0].title : null
    },
    currentStepDescription() {
       return this.stepsQuestionOfGroup[this.currentStep][0].description ? this.stepsQuestionOfGroup[this.currentStep][0].description : null
    },
    currentStep() {
      return this.stepsIdGroup[this.step] ? this.stepsIdGroup[this.step] : null;
    }
  },

  components: {Step},

  methods: {
    nextStep() {

      this.answersOfStep.push(this.getAnswers());
      this.canNextStep = false;
      this.showCompleteTest = false;

      let answers = this.answersOfStep.reduce(function (acc, item) {
        acc = acc.concat(item);
        return acc
      }, [])

      answers.forEach(function (el) {
        el.completed = true;
      });

        $.ajax({
          url: '/quiz/api/test.php?update_questions',
          'type': 'POST',
          'dataType': 'json',
          data: {
            questions: answers,
            key: this.stepsIdGroup[this.step - 1]
          },
          success: data => {
            if (data['end']) {
              this.$router.push('/preloader');
              return false;
            }
            else {
              axios.get('/quiz/api/test.php?save_result').then(response => {
                this.nextBlock()
              }).catch(error => {
                console.log(error);
              });
            }
          },
          error: error => {
            alert('Произошла ошибка. Если данная ошибка повторится, обратитесь к администратору. Приносим свои извинения. ');
          }
        });

    },
    nextBlock(){
      this.step++;
      $('html, body').animate({
        scrollTop: $('.test-wrapper').offset().top
      }, 1000);
    },

    beforePageDestroyed(){
      axios.get('/quiz/api/test.php?save_result').then(response => {
      }).catch(error => {
        console.log(error);
      });
    },

    handlerCompleteStep(getAnswers) {
      this.getAnswers = getAnswers;
      if(this.step === this.stepsIdGroup.length - 1) {
        this.showCompleteTest = true;
      } else {
        this.canNextStep = true;
      }
    },

    completeTest() {
      this.nextStep();
    }
  },

  mounted: function() {
    axios.get('/quiz/api/test.php?get_questions').then(response => {
      if (response.data.questions == false) {
          alert('Произошла ошибка во время загрузки вопросов');
          this.$router.push(`/`);
          return false;
      }

      let questions = JSON.parse(sessionStorage.getItem('questions'));

      if(questions === null) {
        sessionStorage.setItem('questions', JSON.stringify(response.data))
      }

      this.questions = questions || response.data; //если теряются данные с массивом вопросов при возврате на вкладку

      this.stepsQuestionOfGroup = this.questions.reduce((acc, item) => {
          if(!acc[item.group_id]){
            acc[item.group_id] = [];
          }
          acc[item.group_id].push(item);
          return acc;
        },
        {}
      )
      this.stepsIdGroup = Object.keys(this.stepsQuestionOfGroup)

    }).catch(error => {
        console.log(error);
    });
  }
}
</script>
<style lang='sass'>
</style>



// WEBPACK FOOTER //
// src/components/TestAdult.vue